import React, { useState } from 'react';
import { Flex, Heading, Text, Box } from 'rebass/styled-components';
import RichTextEditor from 'react-rte';
import Select from 'react-select';
import TextInput, { Input } from '../../../components/TextInput';
import { Form, Formik, FormikTouched, FormikErrors } from 'formik';
import FormField from '../../../components/FormField';
import * as Yup from 'yup';
import StarRatings from '../../../components/starRatings/StarRatings';
import { parseStringify } from '../../../utils/StringUtils';
import { EditModalButtons } from './EditModalButtons';
import { IProperties } from './types';
import { IFormMeta } from './Builder';

interface IPreviewInput {
  properties: IProperties,
  name: string,
  touched: FormikTouched<any>,
  errors: FormikErrors<any>
}
interface IPreviewHeading {
  properties: IProperties,
}
const PreviewInput: React.FC<IPreviewInput> = ({ properties, name, touched, errors }, props) => {
  return (
    <Flex flex={1}>
      <Flex flexDirection={'column'} flex={1 / 4}>
        <Text onClick={() => { }} fontWeight={500}>
          {`${((properties || {}).params || {}).question || 'Question'}${(((properties || {}).params || {}).ctrlProps || {}).required ? '*' : ''}`}
        </Text>
        <Text fontSize={'12px'} fontWeight={300}>
          {((properties || {}).params || {}).description || ''}
        </Text>
      </Flex>
      <FormField ml={3} flex={1} mb={0} error={touched[name] && errors[name]}>
        <TextInput name={name} {...((properties || {}).params || {}).ctrlProps} {...props} style={{ height: 'fit-content' }} />
      </FormField>
    </Flex>
  );
};
const PreviewHeadingCtrl: React.FC<IPreviewHeading> = ({ properties }) => {
  console.log({ properties });
  return (
    <>
      <Heading>{`${((properties || {}).params || {}).question || 'Title'}`}</Heading>
    </>
  );
};
interface IPreviewCheckboxes {
  properties: IProperties,
  touched: FormikTouched<any>,
  errors: FormikErrors<any>,
  values: any,
  setFieldValue: (field: string, value: any, shouldValidate?: boolean | undefined) => void
}
const PreviewCheckBoxesCtrl: React.FC<IPreviewCheckboxes> = ({ properties, touched, errors, values, setFieldValue }) => {
  console.log({ properties });
  return (
    <Flex flex={1}>
      <Flex flexDirection={'column'} flex={1 / 4}>
        <Text onClick={() => { }} fontWeight={500}>
          {`${((properties || {}).params || {}).question || 'Question'}${(((properties || {}).params || {}).ctrlProps || {}).required ? '*' : ''}`}
        </Text>
        <Text fontSize={'12px'} fontWeight={300}>
          {((properties || {}).params || {}).description || ''}
        </Text>
      </Flex>
      <Flex ml={3} flex={1} justifyContent={'flex-start'} flexDirection={'column'}>
        {((((properties || {}).params || {}).ctrlProps || {}).options || []).map((x) => {
          return (
            <Flex mb={2}>
              <Input
                type="checkbox"
                checked={values[`${properties.id}__${x.value}`]}
                onClick={(e: any) => setFieldValue(`${properties.id}__${x.value}`, e.target.checked)}
                id={`${properties.id}_${x.value}`}
                name={`${properties.id}_${x.value}`}
              />
              <label htmlFor={`${properties.id}__${x.value}`} style={{ marginLeft: '16px' }}>
                {x.label}
              </label>
            </Flex>
          );
        })}
      </Flex>
    </Flex>
  );
};
const PreviewLineBreakCtrl = () => {
  return (
    <>
      <Flex style={{ width: '100%', height: '2px', backgroundColor: '#344f79' }} />
    </>
  );
};

interface IPreviewRange {
  properties: IProperties,
  name: string,
  values: any,
  setFieldValue: (field: string, value: any, shouldValidate?: boolean | undefined) => void
}
const PreviewRangeCtrl: React.FC<IPreviewRange> = ({ properties, name, setFieldValue, values }) => {
  console.log({ properties });
  return (
    <Flex flex={1}>
      <Flex flexDirection={'column'} flex={1 / 4}>
        <Text onClick={() => { }} fontWeight={500}>
          {`${((properties || {}).params || {}).question || 'Question'}${(((properties || {}).params || {}).ctrlProps || {}).required ? '*' : ''}`}
        </Text>
        <Text fontSize={'12px'} fontWeight={300}>
          {((properties || {}).params || {}).description || ''}
        </Text>
      </Flex>
      <Flex ml={3} flexDirection={'row'} justifyContent={'center'}>
        <input
          {...((properties || {}).params || {}).ctrlProps}
          value={values[name]}
          onChange={(e) => {
            setFieldValue(name, e.target.value);
          }}
        />
        <Text ml={3} alignSelf={'center'}>
          {values[name]}
        </Text>
      </Flex>
    </Flex>
  );
};
const PreviewTextAreaCtrl: React.FC<IPreviewRange> = ({ properties, values, setFieldValue, name }) => {
  console.log({ properties });
  console.log({ aaa: values[name].toString('html') });
  const [valu, setValu] = useState(RichTextEditor.createEmptyValue());
  const toolbarConfig = {
    // Optionally specify the groups to display (displayed in the order listed).
    display: ['INLINE_STYLE_BUTTONS', 'BLOCK_TYPE_BUTTONS', 'LINK_BUTTONS', 'BLOCK_TYPE_DROPDOWN', 'HISTORY_BUTTONS'],
    INLINE_STYLE_BUTTONS: [{ label: 'Bold', style: 'BOLD', className: 'custom-css-class' }, { label: 'Italic', style: 'ITALIC' }, { label: 'Underline', style: 'UNDERLINE' }],
    BLOCK_TYPE_DROPDOWN: [
      { label: 'Normal', style: 'unstyled' },
      { label: 'Heading Large', style: 'header-one' },
      { label: 'Heading Medium', style: 'header-two' },
      { label: 'Heading Small', style: 'header-three' },
    ],
    BLOCK_TYPE_BUTTONS: [{ label: 'UL', style: 'unordered-list-item' }, { label: 'OL', style: 'ordered-list-item' }],
  };
  return (
    <Flex flex={1}>
      <Flex flexDirection={'column'} flex={1 / 4}>
        <Text onClick={() => { }} fontWeight={500}>
          {`${((properties || {}).params || {}).question || 'Question'}${(((properties || {}).params || {}).ctrlProps || {}).required ? '*' : ''}`}
        </Text>
        <Text fontSize={'12px'} fontWeight={300}>
          {((properties || {}).params || {}).description || ''}
        </Text>
      </Flex>
      <Flex ml={3} flex={1} height={'200px'}>
        <RichTextEditor rootStyle={{ width: '100%', flex: 1, height: '200px' }} toolbarConfig={toolbarConfig as any} value={values[name]} onChange={(e) => setFieldValue(name, e)} />
      </Flex>
    </Flex>
  );
};

interface IPreviewDropDown {
  properties: IProperties,
  name: string,
  touched: FormikTouched<any>,
  errors: FormikErrors<any>,
  values: any,
  setFieldValue: (field: string, value: any, shouldValidate?: boolean | undefined) => void
  setFieldTouched: (field: string, isTouched?: boolean | undefined, shouldValidate?: boolean | undefined) => void
}
const PreviewDropdownCtrl: React.FC<IPreviewDropDown> = ({ properties, values, setFieldValue, name, touched, errors, setFieldTouched }) => {
  return (
    <Flex flex={1}>
      <Flex flexDirection={'column'} flex={1 / 4}>
        <Text onClick={() => { }} fontWeight={500}>
          {`${((properties || {}).params || {}).question || 'Question'}${(((properties || {}).params || {}).ctrlProps || {}).required ? '*' : ''}`}
        </Text>
        <Text fontSize={'12px'} fontWeight={300}>
          {((properties || {}).params || {}).description || ''}
        </Text>
      </Flex>
      <Flex ml={3} flex={1} justifyContent={'flex-start'}>
        <div style={{ maxWidth: '500px', alignSelf: 'center', width: '100%' }}>
          <FormField flex={1} mb={0} error={touched[name] && errors[name]}>
            <Select
              className="custom_zindex"
              classNamePrefix="region-select"
              {...((properties || {}).params || {}).ctrlProps}
              styles={{
                // minWidth: '400px',
                menu: (provided) => ({ ...provided, zIndex: 9999 }),
              }}
              onBlur={() => {
                if (!values[name]) setFieldValue(name, '');
                setFieldTouched(name, true);
              }}
              value={((((properties || {}).params || {}).ctrlProps || {}).options || []).find((x) => x.label === values[name])}
              onChange={(e: any) => setFieldValue(name, e.label)}
              noOptionsMessage={() => (
                <div style={{ padding: '12px 24px' }}>
                  <Text textAlign="left" mb={2} fontSize="16px" fontWeight="400">
                    No options set
                  </Text>
                </div>
              )}
              theme={(base) => ({
                ...base,
                colors: {
                  ...base.colors,
                  primary: '#364f79',
                  primary50: '#dae6fa',
                },
              })}
            />
          </FormField>
        </div>
      </Flex>
    </Flex>
  );
};
const PreviewLabelCtrl: React.FC<IPreviewHeading> = ({ properties }) => {
  console.log({ properties });
  return (
    <>
      <Text fontWeight={500}>{`${((properties || {}).params || {}).question || 'Section'}`}</Text>
    </>
  );
};
const PreviewRatingCtrl: React.FC<IPreviewRange> = ({ properties, values, setFieldValue, name }) => {
  return (
    <Flex flex={1}>
      <Flex flexDirection={'column'} flex={1 / 4}>
        <Text onClick={() => { }} fontWeight={500}>
          {`${((properties || {}).params || {}).question || 'Question'}${(((properties || {}).params || {}).ctrlProps || {}).required ? '*' : ''}`}
        </Text>
        <Text fontSize={'12px'} fontWeight={300}>
          {((properties || {}).params || {}).description || ''}
        </Text>
      </Flex>
      <Flex ml={3} flex={1}>
        <StarRatings starEmptyColor="white" starSpacing="0px" starRatedColor="#f9a394" rating={values[name]} numberOfStars={5} changeRating={(e) => setFieldValue(name, e)} starDimension="18px" />
      </Flex>
    </Flex>
  );
};
const PreviewParagraphCtrl: React.FC<IPreviewHeading> = ({ properties }) => {
  console.log({ properties });
  return (
    <>
      <Text fontWeight={300}>{`${((properties || {}).params || {}).question || 'Paragraph'}`}</Text>
    </>
  );
};

const getInitialData = (tree: Array<IProperties>) => {
  console.log({ tree });
  const data: any = {};

  for (let index = 0; index < tree.length; index++) {
    const element = tree[index];
    if (element.key === 'LineBreak' || element.key === 'Header' || element.key === 'Label' || element.key === 'Paragraph') continue;
    if (element.key === 'TextInput' || element.key === 'Email' || element.key === 'Date') {
      data[element.id] = '';
      continue;
    }
    if (element.key === 'Range') {
      data[element.id] = ((element.params || {}).ctrlProps || {}).min || 0;
      continue;
    }
    if (element.key === 'Dropdown') {
      data[element.id] = '';
      continue;
    }
    if (element.key === 'Rating') {
      data[element.id] = 0;
      continue;
    }
    if (element.key === 'NumberInput') {
      data[element.id] = null;
      continue;
    }
    if (element.key === 'TextArea') {
      data[element.id] = RichTextEditor.createEmptyValue(); //.createValueFromString(`<p>aaa <strong>aaa</strong> aaa</p>`,'html')
      continue;
    }

    if (element.key === 'Checkboxes') {
      for (let i2 = 0; i2 < (((element.params || {}).ctrlProps || {}).options || []).length; i2++) {
        const e2 = (((element.params || {}).ctrlProps || {}).options || [])[i2];
        data[`${element.id}__${e2.value}`] = e2.isChecked || false;
      }
    }
  }

  console.log({ data });
  return data;
};
const getSchema = (tree: Array<IProperties>) => {
  let schema: any = {};

  for (let index = 0; index < tree.length; index++) {
    const element = tree[index];
    console.log('is required', ((element.params || {}).ctrlProps || {}).required)
    if (((element.params || {}).ctrlProps || {}).required) {
      if (element.key === 'Email') {
        schema[element.id] = Yup.string()
          .email('Invalid email')
          .required('Required');
      } else if (element.key === 'Date') {
        schema[element.id] = Yup.date().required('Required');
      } else if (element.key === 'NumberInput') {
        schema[element.id] =  Yup.string()
        .trim()
        .min(1, 'Response cannot be empty')
        .required('Required');
      } else {
        schema[element.id] = Yup.string()
          .trim()
          .min(2, 'Response must be greater than 1 character')
          .required('Required');
      }
    }
  }
  return Yup.object().shape({ ...schema });
};

interface IPreviewProps {
  tree: Array<IProperties>,
  meta: IFormMeta,
  close: () => void
}
export const PreviewHcForm: React.FC<IPreviewProps> = ({ meta, tree, close }) => {
  console.log('PreviewHcForm');
  const [data, setData] = useState(getInitialData(tree));
  const [schema] = useState(getSchema(tree));
  const [outputResult, setOutputResult] = useState<string | null>(null);
  console.log(schema);
  return (
    <Flex style={{}} flexDirection={'column'}>
      {/* <Heading mt={4} mb={3}>
        {meta.name}
      </Heading>
      <Text mb={4}>{meta.description}</Text>
      <PreviewLineBreakCtrl /> */}
      <Box mb={4} />
      {!outputResult ? (
        <Formik
          initialValues={{ ...getInitialData(tree) }}
          validationSchema={getSchema(tree)}
          isInitialValid={() => {
            try {
              const aa = schema.isValidSync({ ...getInitialData(tree) });

              // const bb = await aa.isValid()
              return aa
            } catch (err) {
              return false;
            }
          }}
          onSubmit={(values, actions) => {
            console.log({ values });
            let res: any = {};
            const resTree = parseStringify(tree);

            for (const key in values) {
              if (key.indexOf('Checkboxes_') > -1) {
                const sp = key.split('__');
                if (!!sp && sp.length > 1) {
                  const a2 = resTree.findIndex((x: any) => x.id === sp[0]);
                  if (!resTree[a2].values) {
                    resTree[a2].values = [];
                  }
                  resTree[a2].values.push({
                    [sp[1]]: (values as any)[key],
                  });
                }
                continue;
              }
              const a = resTree.findIndex((x: any) => x.id === key);

              if (key.indexOf('TextArea_') < 0) {
                res[key] = (values as any)[key];
                resTree[a].value = (values as any)[key];
              } else {
                const s = (values as any)[key].toString('html');
                res[key] = s;
                resTree[a].value = s;
              }
            }
            console.log({ resTree });
            setOutputResult(JSON.stringify(resTree, null, 4));
          }}
        >
          {({ touched, errors, isValid, values, submitForm, setFieldValue, setFieldTouched }) => {
            console.log({ errors, touched, values });
            return (
              <Form>
                <>
                  {tree.map((treeItem) => (
                    <Flex
                      width={'100%'}
                      style={{
                        padding: treeItem.key === 'Header' ? '12px 0 20px 0' : treeItem.key === 'Label' ? '18px 0 12px' : treeItem.key === 'LineBreak' ? '6px 0' : '6px 0 12px 32px',
                      }}
                    >
                      {treeItem.key === 'TextInput' || treeItem.key === 'NumberInput' || treeItem.key === 'Email' || treeItem.key === 'Date' ? (
                        <PreviewInput properties={treeItem} name={treeItem.id} touched={touched} errors={errors} />
                      ) : null}
                      {treeItem.key === 'LineBreak' ? <PreviewLineBreakCtrl /> : null}
                      {treeItem.key === 'Checkboxes' ? <PreviewCheckBoxesCtrl properties={treeItem} touched={touched} errors={errors} values={values} setFieldValue={setFieldValue} /> : null}
                      {treeItem.key === 'Header' ? <PreviewHeadingCtrl properties={treeItem} /> : null}
                      {treeItem.key === 'Range' ? <PreviewRangeCtrl name={treeItem.id} values={values} setFieldValue={setFieldValue} properties={treeItem} /> : null}
                      {treeItem.key === 'TextArea' ? <PreviewTextAreaCtrl name={treeItem.id} values={values} setFieldValue={setFieldValue} properties={treeItem} /> : null}
                      {treeItem.key === 'Dropdown' ? (
                        <PreviewDropdownCtrl
                          name={treeItem.id}
                          values={values}
                          setFieldTouched={setFieldTouched}
                          setFieldValue={setFieldValue}
                          properties={treeItem}
                          touched={touched}
                          errors={errors}
                        />
                      ) : null}
                      {treeItem.key === 'Label' ? <PreviewLabelCtrl properties={treeItem} /> : null}
                      {treeItem.key === 'Rating' ? <PreviewRatingCtrl name={treeItem.id} values={values} setFieldValue={setFieldValue} properties={treeItem} /> : null}
                      {treeItem.key === 'Paragraph' ? <PreviewParagraphCtrl properties={treeItem} /> : null}
                    </Flex>
                  ))}
                  <EditModalButtons save={submitForm} close={close} isValid={isValid} saveBtnCode={'View generated code'} />
                </>
              </Form>
            );
          }}
        </Formik>
      ) : (
        <div><pre>{outputResult}</pre></div>
      )}
    </Flex>
  );
};
